<template>
  <div :to="{ name: '報到詳細頁' }" class="course-area__col">
    <router-link
      :to="{
        name: '報到詳細頁',
        params: {
          schedule_time_id: schedule.schedule_time_id,
          date: date
        }
      }"
      class="course-block"
    >
      <p class="course-block__time">
        {{ schedule.start_at }}-{{ schedule.end_at }}
      </p>
      <p
        class="course-block__name"
        :style="`color:${schedule.course.color_code}`"
      >
        {{ schedule.course.name }}
      </p>

      <p class="course-block__teacher">{{ schedule.user.name }}</p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    schedule: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
